<template>
  <QTextArea
    v-model="localValue"
    :label="label"
    :hint="hint"
    :rows="5"
    :autoGrow="true"
    :multiple="true"
    :persistentHint="!!hint"
    :rules="rules"
    :placeholder="definition.DefaultValue"
    externaledit
    clearable
  />
</template>

<script>
import QTextArea from "@/components/Inputs/QTextArea.vue";

export default {
  name: "QAIFieldNote",
  components: { QTextArea },
  props: {
    value: { type: [String, Number], default: "" },
    definition: { type: Object, required: true },
  },
  computed: {
    localValue: {
      get() { return this.value; },
      set(v) { this.$emit("input", v); },
    },
    label() {
      return this.definition.Description || this.definition.Name;
    },
    hint() {
      return this.definition.DefaultValue ? `Default: ${this.definition.DefaultValue}` : "";
    },
    rules() {
      return this.definition.IsRequired ? [v => !!v || `${this.definition.Name} is required`] : [];
    },
  },
};
</script>
